var _path, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgChatMainTabFiledIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 10.0833C20.0028 11.1832 19.7459 12.2682 19.25 13.25C18.662 14.4265 17.7581 15.416 16.6395 16.1077C15.5209 16.7995 14.2319 17.1662 12.9167 17.1667C11.8168 17.1695 10.7318 16.9126 9.74999 16.4167L5 18L6.58333 13.25C6.08744 12.2682 5.83046 11.1832 5.83333 10.0833C5.83384 8.76815 6.20051 7.47906 6.89226 6.36048C7.58402 5.24189 8.57354 4.33799 9.74999 3.75002C10.7318 3.25413 11.8168 2.99716 12.9167 3.00002H13.3333C15.0703 3.09585 16.7109 3.82899 17.9409 5.05907C19.171 6.28915 19.9042 7.92973 20 9.66668V10.0833Z",
    fill: "url(#paint0_linear_78_9169)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_78_9169",
    x1: 4.025,
    y1: 10.5,
    x2: 19.0573,
    y2: 18.352,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8747F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4D60F4"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatMainTabFiledIcon);
export default __webpack_public_path__ + "static/media/chat-main-tab-filed-icon.f02d3ee7d5127af99b0cf1608d3cd5f5.svg";
export { ForwardRef as ReactComponent };